import {sortBy} from "lodash";

export const array_utilities = {

    array_join_with_string: function ( array, separatorAsstring, skipEmptyAsBoolean )
    {
        var joined = '';
        skipEmptyAsBoolean = !! skipEmptyAsBoolean;
        array_utilities.array_foreach( array, function( item ){

            var canAppend;

            if( skipEmptyAsBoolean )
            {
                if( item )
                {
                    canAppend = true;
                }
                else
                {
                    canAppend = false;
                }
            }
            else
            {
                canAppend = true;
            }

            if( canAppend )
            {
                if( joined )
                {
                    joined += separatorAsstring;
                }
                joined += item;
            }
        });
        return joined;
    },

    array_foreach: function ( array, eachCallback )
    {
        for( var unsafeKey in array )
        {
            if( array.hasOwnProperty( unsafeKey ))
            {
                eachCallback( array[unsafeKey], unsafeKey );
            }
        }
    },

    array_locale_sort: function ( array )
    {

        //
        // Redux calls fetch() periodically!
        // Redux wants immutability so duplicate array
        //
        array = array.slice();

        return array.sort( function( aString, bString ) {
            var aValue = aString.toLocaleLowerCase();
            var bValue = bString.toLocaleLowerCase();
            return aValue.localeCompare( bValue );
        });
    },

    array_of_structs_locale_sort_by_field_name: function ( array, fieldName )
    {
        if( array )
        {
            if (typeof array.sort !== 'undefined')
            {
                //
                // Redux calls fetch() periodically!
                // Redux wants immutability so duplicate array
                //
                array = array.slice();

                return array.sort( function( aStruct, bStruct ) {
                    var aValue = aStruct[ fieldName ].toLocaleLowerCase();
                    var bValue = bStruct[ fieldName ].toLocaleLowerCase();
                    return aValue.localeCompare( bValue );
                });
            }
            else
            {
                return array;
            }
        }
        else
        {
            return array;
        }
    },

    /**
     * @fieldNameArray: nonempty array of field names
     */
    array_of_structs_locale_sort_by_array_of_field_names: function ( array, fieldNameArray )
    {
        if( array )
        {
            if (typeof array.sort !== 'undefined')
            {
                //
                // Redux calls fetch() periodically!
                // Redux wants immutability so duplicate array
                //
                array = array.slice();

                return array.sort( function( aStruct, bStruct ) {

                    var comparison = 0;

                    for( var index in fieldNameArray )
                    {
                        var aValueUnsafe = aStruct[ fieldNameArray[ index ]];
                        var bValueUnsafe = bStruct[ fieldNameArray[ index ]];
                        var aIsOk = typeof( aValueUnsafe ) !== 'undefined' && aValueUnsafe !== null;
                        var bIsOk = typeof( bValueUnsafe ) !== 'undefined' && bValueUnsafe !== null;

                        if( aIsOk && bIsOk )
                        {
                            var aValue = aValueUnsafe.toLocaleLowerCase();
                            var bValue = bValueUnsafe.toLocaleLowerCase();
                            comparison = aValue.localeCompare( bValue );
                            //debugger;
                            if (comparison !== 0) {
                                break;
                            }
                        }
                        else
                        {
                            //debugger;
                            if( aIsOk === bIsOk )
                            {
                                comparison = 0; // keep comparing ...
                            }
                            else
                            {
                                comparison = aIsOk > bIsOk ? 1 : -1;
                            }
                        }
                    }

                    return comparison;
                });
            }
            else
            {
                return array;
            }
        }
        else
        {
            return array;
        }
    },

    _test: function()
    {
        array_utilities.array_locale_sort( null );
        array_utilities.array_locale_sort( "do not sort" );
        array_utilities.array_locale_sort( -1 );
        array_utilities.array_locale_sort([]);
        array_utilities.array_locale_sort([ "Ab -3","aa -2","z -4","4life -1" ]);
        array_utilities.array_locale_sort([[ 'único -4','árbol -1', 'cosas -2', 'fútbol -3' ]]);
    }
};


// WEBPACK FOOTER //
// ./src/Atollon/utilities/array_utilities.js